var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEr1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4183 5.43819C14.9634 5.4324 15.5083 5.46317 16.0493 5.53029C16.6191 5.55614 17.1729 5.72515 17.6591 6.02153C18.1453 6.31791 18.548 6.73198 18.8294 7.22503C18.9841 7.53311 19.0527 7.87678 19.0283 8.22022C19.0038 8.56365 18.8872 8.89429 18.6904 9.17766C18.3012 9.77635 17.6896 10.2 17.3282 10.8171C17.2452 10.9465 17.1903 11.0917 17.1669 11.2433C17.1435 11.395 17.1522 11.5498 17.1923 11.698C17.2324 11.8461 17.3031 11.9843 17.3998 12.1038C17.4966 12.2234 17.6174 12.3215 17.7544 12.3921C18.5792 12.8711 19.5059 13.1474 20.3307 13.6171C20.8753 13.9037 21.351 14.3039 21.7253 14.7904C22.0996 15.2769 22.3636 15.8381 22.4992 16.4356C22.6054 16.9618 22.5761 17.5062 22.4141 18.0183C22.2521 18.5303 21.9626 18.9934 21.5725 19.3645C21.3297 19.5647 21.0494 19.715 20.7477 19.8066C19.821 20.0829 18.6441 19.8066 16.4941 19.2632C14.3442 18.7198 12.917 17.7803 6.33742 18.2224C5.41071 18.2224 2.25065 18.4066 1.57415 15.9198C0.897656 13.4329 3.42756 10.3106 5.87407 8.55135C8.33215 6.66481 11.3158 5.57768 14.4183 5.43819V5.43819Z",
    stroke: "#35383D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83984 10.0988C10.6743 8.80224 12.8928 8.15371 15.1414 8.25672",
    stroke: "#35383D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEr1);
export default __webpack_public_path__ + "static/media/er-1.152df26cfa7b5f43e7bbad2031177db4.svg";
export { ForwardRef as ReactComponent };